import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import { blockAgent, getAgentWithCreditLimitFxn } from '../actions/user'
import {
  anyNumberConvertInWord,
  DefaultTablePagination,
  formatRupees
} from '../../../components/_utils/appUtils'
import { listAllCountries } from '../../countries/actions/countries'
import { CheckMyRights } from '../../WebComponent/CheckUserRights'
import { ColumnWidth } from '../../WebComponent/columnWidth'
import { Tooltip } from 'antd'
import AllCreditLimitListDrawer from './allXTravelCreditLimitList'
import AllTransfersDrawer from './allXTravelTransfers'

class xTravelCreditLimitList extends Component {

  events = {
    showUserRightDrawer: (data) => {
      this.setState({
        visibleUserRightDrawer: true,
        selectedUser: data
      })
    },
    hideUserRightDrawer: () => {
      this.setState({
        visibleUserRightDrawer: false,
        selectedUser: {}
      })
    },
    closeAndUpdateUserRightDrawer: () => {
      this.setState({
        visibleUserRightDrawer: false,
        selectedUser: {}
      }, () => {
        this.tableRef.current.reload()
      })
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      viewInfoDrawer: false,
      selectedRow: {},
      allAgents: [],
      allBranchManager: [],
      allCountry: [],
      selectedUser: {},
      visibleUpdatePassword: false,
      visibleUpdateUser: false,
      visibleUpdateSubAgent: false,
      visibleUserRightDrawer: false,
      visibleCreditLimitListDrawer: false,
      visibleAllTransfersDrawer: false,
      agentId: ''
    }
    this.tableRef = React.createRef()
  }

  componentDidMount() {
    this.loadAllCountry()

    // Wait a bit before trying to scroll
    setTimeout(() => {
      const el = document.getElementById('creditLimitTable')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }, 1000)
  }

  apiRequest = (params) => {
    let { dispatch } = this.props
    return new Promise(async (resolve) => {
      let resp = await dispatch(getAgentWithCreditLimitFxn({
        ...params
      }))
      this.setState({ totalBranchUser: resp.total })
      resolve(resp.data)
    })
  }

  async loadAllCountry() {
    let { dispatch } = this.props
    let { data } = await dispatch(listAllCountries())
    this.setState({ allCountry: data })
  }

  viewInfo(record) {
    this.setState({
      selectedRow: record,
      viewInfoDrawer: true
    })
  }

  onClose = () => {
    this.setState({
      selectedRow: {},
      viewInfoDrawer: false
    })
  }

  closeUpdatePassword = () => {
    this.setState({
      selectedUser: {},
      visibleUpdatePassword: false
    }, () => {
      this.tableRef.current.reload()
    })
  }

  closeEditUser = () => {
    this.setState({
      selectedUser: {},
      visibleUpdateUser: false
    }, () => {
      this.tableRef.current.reload()
    })
  }

  closeEditSubAgent = () => {
    this.setState({
      selectedUser: {},
      visibleUpdateSubAgent: false
    }, () => {
      this.tableRef.current.reload()
    })
  }

  updateAgentBlockStatus = async (id) => {
    let { dispatch } = this.props
    let resp = await dispatch(blockAgent({ agentId: id }))
    if (resp && resp.success) {
      this.tableRef.current.reload()
    }
  }

  showCreditLimitDrawer(agentId, name, companyName, creditLimit) {
    this.setState({
      agentId: agentId,
      name: name,
      companyName: companyName,
      creditLimit: creditLimit,
      visibleCreditLimitListDrawer: true
    })
  }

  hideCreditLimitDrawer() {
    this.setState({
      agentId: '',
      visibleCreditLimitListDrawer: false
    })
  }

  showAllTransfers(agentId, name, companyName, currentBalance) {
    this.setState({
      agentId: agentId,
      name: name,
      companyName: companyName,
      currentBalance: currentBalance,
      visibleAllTransfersDrawer: true
    })
  }

  hideAllTransfers() {
    this.setState({
      agentId: '',
      visibleAllTransfersDrawer: false
    })
  }

  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => {
          return (
            <React.Fragment>
              {index + 1}
            </React.Fragment>
          )
        }
      },
      {
        title: 'Name',
        key: 'name',
        sorter: true,
        dataIndex: 'name',
        searchTextName: 'name',
        width: 200,
        render: (item, record) => {
          return (
            <ColumnWidth width={200}>
              {item}({record.companyName})
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        searchTextName: 'email',
        width: 120,
        render: (item) => {
          return (
            <ColumnWidth width={120}>{item}</ColumnWidth>
          )
        }
      },
      {
        title: 'Mobile No',
        dataIndex: 'mobile',
        key: 'mobile',
        searchTextName: 'mobile',
        width: 80,
        render: (item) => {
          return (
            <ColumnWidth width={80}>{item}</ColumnWidth>
          )
        }
      },
      {
        title: 'Credit Limit',
        dataIndex: 'xTravelCreditLimit',
        key: 'xTravelCreditLimit',
        width: 100,
        render: (item, record) => {
          return (
            <ColumnWidth width={100}>
              <div className={'mt10 label label-default pointerCls'}
                   onClick={() => {
                     this.showCreditLimitDrawer(record._id, record.name, record.companyName, item)
                   }}
              >
                <Tooltip title={anyNumberConvertInWord(item)}>
                  {formatRupees(item, 2)}
                </Tooltip>
              </div>
            </ColumnWidth>
          )
        }

      },
      {
        title: 'Current Balance',
        dataIndex: 'xTravelWallet',
        key: 'xTravelWallet',
        width: 100,
        render: (item, record) => {
          return (
            <ColumnWidth width={100}>
              <div className={'mt10 label label-info pointerCls'}
                   onClick={() => {
                     this.showAllTransfers(record._id, record.name, record.companyName, item)
                   }}
              >
                <Tooltip title={anyNumberConvertInWord(item)}>
                  {formatRupees(item, 2)}
                </Tooltip>
              </div>
            </ColumnWidth>
          )
        }

      },
      {
        title: 'Limit Used',
        dataIndex: 'xTravelCreditLimit',
        key: 'xTravelCreditLimit',
        sorter: true,
        width: 100,
        render: (item, record) => {
          return (
            <ColumnWidth width={100}>
              <div className={`mt10 label ${
                item - record.xTravelWallet < 0 ? 'label-success-green' : 'label-danger'
              }`}>
                <Tooltip title={anyNumberConvertInWord(item - record.xTravelWallet)}>
                  {formatRupees((item - record.xTravelWallet), 2)}
                </Tooltip>
              </div>

            </ColumnWidth>
          )
        }
      }
    ]
    return (
      <div>

        <div className='row  mt-4' id='creditLimitTable'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='table-head d-flex align-items-center'>
                <h5>XTravelWorld Credit Limit List</h5>
                <div className='search-box-table'>

                </div>

                <CheckMyRights rightList={['admin']}>
                  <div className='sort-box-table mark-btn'>
                    <div>
                      {/*<a className='btn' onClick={() => dispatch(push('/user/add-master'))}>
                        <img src={'../dist/icons/plus.png'} className={'plus'} /> Add Master
                      </a>*/}
                    </div>
                  </div>
                </CheckMyRights>
              </div>
              <div className='card-body table-responsive'>
                <TableComp columns={columns}
                           ref={this.tableRef}
                           pagination={DefaultTablePagination()}
                           apiRequest={this.apiRequest}
                           extraProps={{ scroll: { x: 1000 } }}
                />
              </div>
              {this.state.visibleCreditLimitListDrawer ?
                <AllCreditLimitListDrawer
                  visible={this.state.visibleCreditLimitListDrawer}
                  agentId={this.state.agentId}
                  name={this.state.name}
                  companyName={this.state.companyName}
                  creditLimit={this.state.creditLimit}
                  onClose={() => {
                    this.hideCreditLimitDrawer()
                  }}
                /> : null
              }
              {this.state.visibleAllTransfersDrawer ?
                <AllTransfersDrawer
                  visible={this.state.visibleAllTransfersDrawer}
                  agentId={this.state.agentId}
                  name={this.state.name}
                  companyName={this.state.companyName}
                  currentBalance={this.state.currentBalance}
                  onClose={() => {
                    this.hideAllTransfers()
                  }}
                /> : null
              }
            </div>
          </div>
        </div>
      </div>)

  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(xTravelCreditLimitList)
